/*
  MacShack home page: rotating hero headline (sections/ms-home.liquid).
  - The page loads with headline 1 in the H1 (what search engines and no-JS visitors see).
  - On load a random headline plays in, never the same one twice in a row for a visitor.
  - It changes every few seconds ("Liquid rise": letters blur up and away, new ones rise into focus).
  - The underline under the headline fills up as a timer. It pauses on hover, when the hero is
    off screen, when the tab is hidden, or with the pause button.
  - Reduce Motion: a simple fade instead of the letter animation.
  - Photos: when the headline changes, the three hero photos change to that headline's photo set
    (blur-to-sharp crossfade, large photo first). The first set is what the page loads; other sets
    are fetched quietly after the page has loaded. On phones only the large photo changes.
*/
(function () {
  var h1 = document.querySelector('[data-mhp-hl]');
  if (!h1) return;
  var done = function () { h1.classList.remove('hl-wait'); };
  var H = [];
  try { H = JSON.parse(document.querySelector('[data-mhp-hl-list]').textContent) || []; } catch (e) { H = []; }
  H = H.filter(function (t) { return t && t.length === 3 && t.every(function (x) { return x && String(x).trim(); }); });
  var lines = Array.prototype.filter.call(h1.children, function (el) { return el.tagName === 'SPAN' && !el.classList.contains('kicker'); });
  if (lines.length !== 3 || H.length < 2 || !Element.prototype.animate) { done(); return; }

  var secs = parseFloat(h1.getAttribute('data-seconds')) || 7;
  var DUR = Math.max(3, secs) * 1000;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var copy = h1.closest('.hero__copy') || h1.parentElement;
  var fill = document.querySelector('[data-hl-fill]');
  var pauseBtn = document.querySelector('[data-hl-pause]');
  var idx = 0, busy = false, userPaused = false, hovering = false, offscreen = false, fillAnim = null;

  // Screen readers get the whole headline as one phrase; the letters are hidden from them.
  var said = document.createElement('span');
  said.className = 'hl-vh';
  h1.appendChild(said);
  lines.forEach(function (ln, k) {
    ln.classList.add('hl__ln');
    if (k === 1) { ln.classList.add('hl__ln--g'); ln.classList.remove('grad-text'); }
    ln.setAttribute('aria-hidden', 'true');
  });

  /* ---------- Size: one font size that fits the longest line of every headline ---------- */
  function fit() {
    h1.style.removeProperty('font-size');
    var fs = parseFloat(getComputedStyle(h1).fontSize);
    var m = document.createElement('span');
    m.className = 'hl-measure';
    h1.appendChild(m);
    var widest = 0;
    H.forEach(function (t) { t.forEach(function (x) { m.textContent = x; widest = Math.max(widest, m.getBoundingClientRect().width); }); });
    m.remove();
    var room = copy.clientWidth - 4;
    if (widest > room) h1.style.setProperty('font-size', Math.floor(fs * room / widest) + 'px', 'important');
  }

  /* ---------- Letters ---------- */
  function build(box, text) {
    box.textContent = '';
    String(text).split('').forEach(function (c) {
      var s = document.createElement('span');
      if (c === ' ') { s.className = 'sp'; s.textContent = ' '; } else { s.className = 'ch'; s.textContent = c; }
      box.appendChild(s);
    });
    if (box.closest('.hl__ln--g')) paint(box);
    return Array.prototype.slice.call(box.querySelectorAll('.ch'));
  }
  // One continuous gradient across the line, although every letter is its own element.
  // It repeats every two line-widths (purple, orange, purple), so a sweep of two widths ends where it began.
  function paint(box) {
    var chs = box.querySelectorAll('.ch'), last = chs[chs.length - 1];
    if (!last) return;
    var w = last.offsetLeft + last.offsetWidth;
    box.setAttribute('data-w', w);
    Array.prototype.forEach.call(chs, function (c) {
      c.style.backgroundSize = (w * 2) + 'px 100%';
      c.style.backgroundPosition = (-c.offsetLeft) + 'px 0';
      c.setAttribute('data-x', c.offsetLeft);
    });
  }
  function sweep(box, delay) {
    var w = +box.getAttribute('data-w') || 0;
    Array.prototype.forEach.call(box.querySelectorAll('.ch'), function (c) {
      var x = +c.getAttribute('data-x');
      c.animate([{ backgroundPosition: (-x) + 'px 0' }, { backgroundPosition: (-x - 2 * w) + 'px 0' }], { duration: 1800, delay: delay, easing: 'cubic-bezier(.45,0,.2,1)' });
    });
  }
  // The incoming headline is drawn on a layer over the outgoing one so the two overlap.
  function settle() {
    lines.forEach(function (ln) {
      var nw = ln.querySelector('.hl__nw');
      if (!nw) return;
      Array.prototype.slice.call(ln.children).forEach(function (c) { if (c !== nw) c.remove(); });
      while (nw.firstChild) ln.appendChild(nw.firstChild);
      nw.remove();
      if (ln.classList.contains('hl__ln--g')) paint(ln);
    });
  }

  /* ---------- Liquid rise ---------- */
  function liquid(t) {
    var all = [];
    lines.forEach(function (ln, k) {
      Array.prototype.forEach.call(ln.querySelectorAll(':scope > .ch'), function (c, j) {
        all.push(c.animate([
          { transform: 'translateY(0)', filter: 'blur(0)', opacity: 1 },
          { transform: 'translateY(-.3em)', filter: 'blur(12px)', opacity: 0 }
        ], { duration: 520, delay: k * 60 + j * 12, easing: 'cubic-bezier(.5,0,.75,0)', fill: 'forwards' }).finished);
      });
      var nw = document.createElement('span');
      nw.className = 'hl__nw';
      ln.appendChild(nw);
      build(nw, t[k]).forEach(function (c, j) {
        all.push(c.animate([
          { transform: 'translateY(.5em) scale(.96)', filter: 'blur(16px)', opacity: 0 },
          { transform: 'translateY(-.03em) scale(1)', filter: 'blur(0)', opacity: 1, offset: .72 },
          { transform: 'translateY(0)', filter: 'blur(0)', opacity: 1 }
        ], { duration: 1000, delay: 280 + k * 110 + j * 24, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' }).finished);
      });
      if (k === 1) sweep(nw, 380 + k * 110);
    });
    return Promise.all(all);
  }
  function fade(t) {
    return h1.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 250, easing: 'ease-in' }).finished.then(function () {
      lines.forEach(function (ln, k) { build(ln, t[k]); });
      return h1.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 450, easing: 'ease-out' }).finished;
    });
  }

  function show(i, first) {
    var t = H[i];
    idx = i;
    said.textContent = t.join(' ');
    busy = true;
    if (!first && PH) swapTo(setFor(i));
    return (reduced ? fade(t) : liquid(t)).then(function () { settle(); busy = false; }, function () { settle(); busy = false; });
  }

  /* ---------- Timer: the underline fills, then the next headline plays ---------- */
  function paused() { return userPaused || hovering || offscreen || document.hidden; }
  function startTimer() {
    if (fillAnim) fillAnim.cancel();
    if (!fill) { fillAnim = document.body.animate([{ opacity: 1 }, { opacity: 1 }], { duration: DUR }); }
    else { fillAnim = fill.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: DUR, easing: 'linear', fill: 'forwards' }); }
    if (paused()) fillAnim.pause();
    var mine = fillAnim;
    fillAnim.finished.then(function () { if (mine === fillAnim) next(); }, function () {});
  }
  function next() {
    if (busy) return;
    if (fillAnim) fillAnim.cancel();
    show((idx + 1) % H.length).then(startTimer);
  }
  function update() {
    if (!fillAnim) return;
    if (paused()) fillAnim.pause(); else if (fillAnim.playState === 'paused') fillAnim.play();
  }

  copy.addEventListener('mouseenter', function () { hovering = true; update(); });
  copy.addEventListener('mouseleave', function () { hovering = false; update(); });
  document.addEventListener('visibilitychange', update);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { offscreen = !es[0].isIntersecting; update(); }, { threshold: 0.2 }).observe(h1);
  }
  if (pauseBtn) {
    pauseBtn.hidden = false;
    pauseBtn.addEventListener('click', function () {
      userPaused = !userPaused;
      pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      pauseBtn.setAttribute('aria-label', userPaused ? 'Play headlines' : 'Pause headlines');
      update();
    });
  }
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { fit(); var g = lines[1]; if (!g.querySelector('.hl__nw')) paint(g); }, 150);
  });


  /* ---------- Photos that follow the headline ---------- */
  var PH = null;
  try { PH = JSON.parse(document.querySelector('[data-mhp-ph]').textContent); } catch (e) { PH = null; }
  var stack = document.querySelector('.hero__stack');
  var slots = stack ? ['a', 'b', 'c'].map(function (k) { return stack.querySelector('.ph--' + k); }) : [];
  var phone = window.matchMedia('(max-width: 749px)');
  var shownSet = 0, cache = {};
  function setFor(i) {
    if (!PH || !PH.map) return 0;
    var n = (PH.map[i] || 1) - 1;
    return (n >= 0 && n < PH.sets.length) ? n : 0;
  }
  function slotsInUse() { return phone.matches ? [0] : [0, 1, 2]; }
  function want(n) { // the photos of set n that this screen size would swap
    var set = PH.sets[n] || [];
    return slotsInUse().filter(function (k) { return set[k] && slots[k]; });
  }
  function prep(n, k) { // load (and decode) one photo, once
    var key = n + '-' + k, p = PH.sets[n][k];
    if (cache[key]) return cache[key];
    var img = new Image();
    img.decoding = 'async';
    img.sizes = p.sizes; img.srcset = p.srcset; img.src = p.src; img.alt = p.alt || '';
    cache[key] = { img: img, ready: false };
    var c = cache[key];
    (img.decode ? img.decode() : Promise.resolve()).then(function () { c.ready = true; }, function () { c.failed = true; });
    return c;
  }
  function prepSet(n) { want(n).forEach(function (k) { prep(n, k); }); }
  function swapTo(n) {
    if (!PH || n === shownSet) return;
    var ks = want(n);
    // Only swap when every photo of the set is ready, so a set never shows half old, half new.
    if (!ks.length || !ks.every(function (k) { return prep(n, k).ready; })) { prepSet(n); return; }
    shownSet = n;
    ks.forEach(function (k, j) {
      var fig = slots[k], old = fig.querySelectorAll('img'), src = cache[n + '-' + k].img;
      var img = src.cloneNode();
      img.className = 'ph__in';
      var pos = old.length ? old[old.length - 1].style.objectPosition : '';
      if (pos) img.style.objectPosition = pos;
      fig.appendChild(img);
      var a = reduced
        ? img.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 450, delay: j * 80, easing: 'ease-out', fill: 'backwards' })
        : img.animate([
            { opacity: 0, filter: 'blur(14px)', transform: 'scale(1.06)' },
            { opacity: 1, filter: 'blur(0)', transform: 'scale(1)' }
          ], { duration: 1100, delay: 180 + j * 120, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' });
      a.finished.then(function () {
        Array.prototype.forEach.call(old, function (o) { o.remove(); });
        img.classList.remove('ph__in');
      }, function () {});
    });
  }
  function warmUp() { // after the page has loaded, fetch the other sets one by one
    if (!PH) return;
    var order = [];
    for (var j = 1; j <= H.length; j++) { var n = setFor((idx + j) % H.length); if (order.indexOf(n) < 0) order.push(n); }
    var go = function () { var n = order.shift(); if (n === undefined) return; prepSet(n); setTimeout(go, 600); };
    go();
  }
  if (PH && slots[0]) {
    if (document.readyState === 'complete') setTimeout(warmUp, 1200);
    else window.addEventListener('load', function () { setTimeout(warmUp, 1200); });
    phone.addEventListener && phone.addEventListener('change', function () { cache = {}; warmUp(); });
  }

  /* ---------- Start: a random headline, not the one this visitor saw last time ---------- */
  fit();
  var last = -1;
  try { last = parseInt(localStorage.getItem('mhp-hl'), 10); } catch (e) {}
  var start = Math.floor(Math.random() * H.length);
  if (start === last) start = (start + 1) % H.length;
  try { localStorage.setItem('mhp-hl', String(start)); } catch (e) {}
  lines.forEach(function (ln) { ln.textContent = ''; });
  done();
  show(start, true).then(startTimer);
})();
